import utils from "../../../utils/utils.js";

export default {

  async fetchWorkspaceActiveEmojis(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceActiveEmojis`,
      "GET",
      null,
      null
    );
    context.commit("setEmojis", response.data);
  },

  async changeEngagementWorkspaceActiveEmojis(context, payload) {
    let postData = { emojiCodeList: payload.emojiCodeList };
     await utils.utility.fetch(
      `api/Setting/ChangeEngagementWorkspaceActiveEmojis`,
      "POST",
      null,
      postData
    );
  },

   async fetchWorkspaceEmojiIsEnabled(context) {
      const response = await utils.utility.fetch("api/Setting/GetWorkspaceEmojiIsEnabled", "GET", null, null, true);
          
      context.commit("setEmojisIsEnabled", response.data);
    },
};
